import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Link as RouterLink } from 'react-router-dom'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'

export function UnauthorizedPage() {
  useDocumentTitle('Access denied')

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        px: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
        Access denied
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 2, maxWidth: 480 }}>
        You do not have permission to view this page. If you believe this is a mistake,
        contact your tenant administrator.
      </Typography>
      <Button
        variant="contained"
        component={RouterLink}
        to="/dashboard"
        sx={{ mt: 3 }}
        data-testid="unauthorized-back-dashboard"
      >
        Back to dashboard
      </Button>
    </Box>
  )
}
